import React, { useMemo } from 'react';
import { useTranslation } from '@/i18n';
import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { RolesForm } from '@/components/features/authorization/RolesForm';
import { PermissionsForm } from '@/components/features/authorization/PermissionsForm';
import { UserProfilingForm } from '@/components/features/authorization/UserProfilingForm';
import { MobileAppPermissionsForm } from '@/components/features/authorization/MobileAppPermissionsForm';
import { AssignedEmployeesForm } from '@/components/features/authorization/AssignedEmployeesForm';
import { usePagePermissions } from '@/hooks/authorization/usePagePermissions';
import { SECTIONS } from '@/types/sections';


export const AuthorizationPage: React.FC = () => {
  const { t: translate } = useTranslation();
  const { canSection } = usePagePermissions();
  const canViewMobileAppPermissions = canSection(SECTIONS.PERMISOS_APP_MOVIL, 'view');

  const tabs = useMemo(() => [
    {
      id: 'roles',
      label: translate('authorization:tabs.roles'),
      content: <RolesForm />,
    },
    {
      id: 'permissions',
      label: translate('authorization:tabs.permissions'),
      content: <PermissionsForm />,
    },
    {
      id: 'userProfiling',
      label: translate('authorization:tabs.userProfiling'),
      content: <UserProfilingForm />,
    },
    ...(canViewMobileAppPermissions
      ? [{
        id: 'mobileAppPermissions',
        label: translate('authorization:tabs.mobileAppPermissions'),
        content: <MobileAppPermissionsForm />,
      }]
      : []),
    {
      id: 'assigned',
      label: translate('authorization:tabs.assigned'),
      content: <AssignedEmployeesForm />,
    },
  ], [canViewMobileAppPermissions, translate]);

  return (
    <PageLayout>
      <div data-testid="authorization-page">
        <TabList tabs={tabs} />
      </div>
    </PageLayout>
  );
};

export default AuthorizationPage;
